import { componentClassName } from '@/styles/Paragraph';
import { StandaloneParagraph } from 'base/components/Paragraph';
import { withSafeInnerHTML } from 'lib/utils';
import mergeProps from 'lib/utils/mergeProps';

export const AllasStandaloneParagraph: typeof StandaloneParagraph = ({ content, attributes, options, ...props }) => {
  const className = componentClassName('', {});

  return (
    <p {...attributes} {...mergeProps({ className }, options as any)} {...props} {...withSafeInnerHTML(content)} />
  );
};

export default AllasStandaloneParagraph;
